import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-request-create',
  templateUrl: './request-create.component.html',
  styleUrls: ['./request-create.component.scss'],
  standalone: false,
})
export class RequestCreateComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
